import React from 'react';
import { LoanSubmissionForm } from './components/LoanSubmissionForm';
export function App() {
  return <LoanSubmissionForm data-id="element-0" />;
}